import { Button, Label, Table, TableCell, TableColumn, TableProps } from "@mcleod/components";
import { AbstractComponentDemoExamples } from "./AbstractComponentDemoExamples";
import { LiveExampleComponents } from "../LiveExampleComponents";

export class DemoTableExamples extends AbstractComponentDemoExamples {
    protected override registerExamples() {
        super.registerExamples();
        this.registerPropertyExamples("busy", {
            examples: [
                {
                    value: true,
                    description: "A table that is busy (loading) displays the rotating spinner icon (commonly called the busy spinner).",
                    onCreate: (exampleComponents: LiveExampleComponents) => {
                        const exampleTable = exampleComponents.liveComponent as Table;
                        this.addColumnsToTable(exampleTable);
                    }
                },
                {
                    value: false,
                    onCreate: (exampleComponents: LiveExampleComponents) => {
                        const exampleTable = exampleComponents.liveComponent as Table;
                        this.addColumnsToTable(exampleTable);
                        const buttonMakeBusy = new Button({
                            caption: "Make Example Table Busy",
                            width: 200,
                            backgroundColor: "primary",
                            color: "primary.reverse",
                            marginLeft: 15,
                            rowBreak: false,
                            onClick: () => {
                                exampleTable.busy = true;
                                buttonMakeBusy.enabled = false;
                                setTimeout(() => {
                                    exampleTable.busy = false;
                                    buttonMakeBusy.enabled = true;
                                }, 5000);
                            }
                        });
                        exampleComponents.liveComponent.rowBreak = false;
                        exampleComponents.livePanel.add(buttonMakeBusy);
                    },
                    description: "A table that becomes busy will remove the busy spinner (and display any data present) when it is no longer busy loading data."
                }
            ]
        });
    }

    // Have to add columns to table this way since the example tables don't pass through deserialization (so adding the
    // columns to the 'all example properties' method has no effect).
    private addColumnsToTable(table: Table) {
        const columnDefs = this.exampleColumns;
        for (let x=0 ; x<columnDefs.length ; x++) {
            table.addColumn(columnDefs[x], x === 0, x === (columnDefs.length -1));
        }
    }

    private get exampleColumns(): TableColumn[] {
        return [
            new TableColumn({
                headingDef: new TableCell({
                    caption: "ID",
                    id: "columnHeaderID",
                    width: "200"
                }),
                cell: new TableCell({
                    id: "tableExample-0-0",
                    width: "200",
                    components: [
                        new Label({
                            fillRow: true,
                            id: "labelID"
                        })
                    ]
                })
            }),
            new TableColumn({
                headingDef: new TableCell({
                    caption: "Description",
                    id: "columnHeaderDescr",
                    width: "350"
                }),
                cell: new TableCell({
                    id: "tableExample-0-1",
                    width: "350",
                    components: [
                        new Label({
                            fillRow: true,
                            id: "labelDescr"
                        })
                    ]
                })
            })
        ];
    }

    protected override get propsForAllExamples(): Partial<TableProps> {
        return {
            ...super.propsForAllExamples,
            minHeight: 300
        };
    }
}
